import { html, SYSBaseElement } from "../../../src"
import {
  HookTableDragDrop,
  HookTableDragDrop_Type,
} from "../../../src/global/hooks"
import { _TableDetailViewRenderer } from "../../../src/library/table/detailview/helpers"
import { DragDropEventType } from "../../../src/library/table/table"
import {
  _TableDetailViewScreenInstance_Type,
  _TableGetReturnType,
  SYSTableDef,
  TableGet,
} from "../../../src/library/table/tableapi"

export class ScreenSYSTableDetailView extends SYSBaseElement {
  detailViewState: _TableDetailViewScreenInstance_Type
  tableData: _TableGetReturnType
  dragAndDropHookFn: any
  async init() {
    this.detailViewState =
      this.state.ovl.libState.tableDetailView.instances[this.screenInstance]

    this.tableData = TableGet(this.detailViewState.defId)

    this.dragAndDropHookFn =
      this.actions.app.features?.[this.tableData.def.feature]?.hooks?.[
        HookTableDragDrop
      ]
    if (this.dragAndDropHookFn) {
      this.removeEventListener("dragstart", this.handleDragStart)
      this.addEventListener("dragstart", this.handleDragStart)
      this.removeEventListener("dragover", this.handleDragOver)
      this.addEventListener("dragover", this.handleDragOver)
      this.removeEventListener("mouseleave", this.removeDragOverClass)
      this.addEventListener("mouseleave", this.removeDragOverClass)
      this.removeEventListener("dragleave", this.handleDragLeave)
      this.addEventListener("dragleave", this.handleDragLeave)
      this.removeEventListener("drop", this.handleDrop)
      this.addEventListener("drop", this.handleDrop)
    }

    await super.init()
  }

  removeDragOverClass = () => {
    let toremove = document.querySelectorAll(".ovl-dragover")
    for (let i = 0; i < toremove.length; i++) {
      toremove[i].classList.remove("ovl-dragover")
    }
  }

  handleDragLeave = (e: DragEvent) => {
    if (!this.contains(e.relatedTarget as Node)) {
      this.removeDragOverClass()
    }
  }

  handleDrop = async (e) => {
    await this.handleDragDrop("drop", e)
    this.removeDragOverClass()
  }

  handleDragOver = (e) => {
    this.handleDragDrop("dragover", e)
  }

  handleDragStart = (e) => {
    this.handleDragDrop("dragstart", e)
  }

  handleDragDrop = async (eventType: DragDropEventType, e: DragEvent) => {
    if (this.dragAndDropHookFn) {
      let colElement: HTMLElement | null = null
      let currentNode: HTMLElement | null = e.target as HTMLElement
      while (currentNode) {
        if (currentNode.getAttribute("data-col")) {
          colElement = currentNode
          break
        }
        currentNode = currentNode.parentElement
      }

      let rowElement = this.querySelector(".ovl-detailview-row") as HTMLElement
      if (!rowElement) {
        if (eventType === "dragover") {
          this.removeDragOverClass()
        }
        return
      }

      let rowKey = this.detailViewState.rowKey
      let row = this.tableData.rows[rowKey]
      let columnKey = colElement ? colElement.getAttribute("data-col") : undefined

      if (eventType === "dragover") {
        const result = await this.dragAndDropHookFn(<HookTableDragDrop_Type>{
          type: eventType,
          e,
          row,
          key: rowKey,
          el: colElement || rowElement,
          formState: undefined,
          columnKey,
          tableDefId: this.tableData.def.id,
        })

        if (result === "RowHit") {
          if (rowElement && !rowElement.classList.contains("ovl-dragover")) {
            this.removeDragOverClass()
            rowElement.classList.add("ovl-dragover")
          }
        } else if (result === "CellHit") {
          if (colElement) {
            if (!colElement.classList.contains("ovl-dragover")) {
              this.removeDragOverClass()
              colElement.classList.add("ovl-dragover")
            }
          } else {
            if (rowElement && !rowElement.classList.contains("ovl-dragover")) {
              this.removeDragOverClass()
              rowElement.classList.add("ovl-dragover")
            }
          }
        } else {
          this.removeDragOverClass()
        }
      } else {
        await this.dragAndDropHookFn(<HookTableDragDrop_Type>{
          type: eventType,
          e,
          row,
          key: rowKey,
          el: colElement || rowElement,
          formState: undefined,
          columnKey,
          tableDefId: this.tableData.def.id,
        })
      }
    }
  }

  async getUI() {
    let tb = TableGet(this.detailViewState.defId)
    let rowKey = this.detailViewState.rowKey
    let row = tb.rows[rowKey]
    let res = await _TableDetailViewRenderer(tb.def, rowKey, row)
    return html`${res}`
  }

  async disconnectedCallback() {
    if (this.dragAndDropHookFn) {
      this.removeEventListener("dragstart", this.handleDragStart)
      this.removeEventListener("dragover", this.handleDragOver)
      this.removeEventListener("drop", this.handleDrop)
      this.removeEventListener("mouseleave", this.removeDragOverClass)
      this.removeEventListener("dragleave", this.handleDragLeave)
    }
    await super.disconnectedCallback()
  }
}
